// utils/generateBlindStructure.ts
import { BlindLevel } from '../../types/config';

export function generateBlindStructure(type: 'turbo' | 'standard' | 'deepstack'): BlindLevel[] {
    let levels: BlindLevel[] = [];

    switch (type) {
        case 'turbo':
            levels = [
                { smallBlind: 100, bigBlind: 200, ante: 200 },
                { smallBlind: 200, bigBlind: 400, ante: 400 },
                { smallBlind: 300, bigBlind: 600, ante: 600 },
                { smallBlind: 400, bigBlind: 800, ante: 800 },
                { smallBlind: 500, bigBlind: 1000, ante: 1000 },
                { smallBlind: 600, bigBlind: 1200, ante: 1200 },
                { smallBlind: 800, bigBlind: 1600, ante: 1600 },
                { smallBlind: 1000, bigBlind: 2000, ante: 2000 },
                { smallBlind: 1200, bigBlind: 2400, ante: 2400 },
                { smallBlind: 1500, bigBlind: 3000, ante: 3000 },
                { smallBlind: 2000, bigBlind: 4000, ante: 4000 },
                { smallBlind: 2500, bigBlind: 5000, ante: 5000 },
                { smallBlind: 3000, bigBlind: 6000, ante: 6000 },
                { smallBlind: 4000, bigBlind: 8000, ante: 8000 },
                { smallBlind: 5000, bigBlind: 10000, ante: 10000 },
                { smallBlind: 6000, bigBlind: 12000, ante: 12000 },
                { smallBlind: 8000, bigBlind: 16000, ante: 16000 },
                { smallBlind: 10000, bigBlind: 20000, ante: 20000 },
                { smallBlind: 12000, bigBlind: 24000, ante: 24000 },
                { smallBlind: 15000, bigBlind: 30000, ante: 30000 },
            ].map(l => ({ ...l, duration: 10 }));
            break;

        case 'standard':
            levels = [
                { smallBlind: 50, bigBlind: 100, ante: 100 },
                { smallBlind: 75, bigBlind: 150, ante: 150 },
                { smallBlind: 100, bigBlind: 200, ante: 200 },
                { smallBlind: 150, bigBlind: 300, ante: 300 },
                { smallBlind: 200, bigBlind: 400, ante: 400 },
                { smallBlind: 300, bigBlind: 600, ante: 600 },
                { smallBlind: 400, bigBlind: 800, ante: 800 },
                { smallBlind: 500, bigBlind: 1000, ante: 1000 },
                { smallBlind: 600, bigBlind: 1200, ante: 1200 },
                { smallBlind: 800, bigBlind: 1600, ante: 1600 },
                { smallBlind: 1000, bigBlind: 2000, ante: 2000 },
                { smallBlind: 1200, bigBlind: 2400, ante: 2400 },
                { smallBlind: 1500, bigBlind: 3000, ante: 3000 },
                { smallBlind: 2000, bigBlind: 4000, ante: 4000 },
                { smallBlind: 2500, bigBlind: 5000, ante: 5000 },
                { smallBlind: 3000, bigBlind: 6000, ante: 6000 },
                { smallBlind: 4000, bigBlind: 8000, ante: 8000 },
                { smallBlind: 5000, bigBlind: 10000, ante: 10000 },
                { smallBlind: 6000, bigBlind: 12000, ante: 12000 },
                { smallBlind: 8000, bigBlind: 16000, ante: 16000 },
            ].map(l => ({ ...l, duration: 20 }));
            break;

        case 'deepstack':
            levels = [
                { smallBlind: 25, bigBlind: 50, ante: 50 },
                { smallBlind: 50, bigBlind: 100, ante: 100 },
                { smallBlind: 75, bigBlind: 150, ante: 150 },
                { smallBlind: 100, bigBlind: 200, ante: 200 },
                { smallBlind: 150, bigBlind: 300, ante: 300 },
                { smallBlind: 200, bigBlind: 400, ante: 400 },
                { smallBlind: 250, bigBlind: 500, ante: 500 },
                { smallBlind: 300, bigBlind: 600, ante: 600 },
                { smallBlind: 400, bigBlind: 800, ante: 800 },
                { smallBlind: 500, bigBlind: 1000, ante: 1000 },
                { smallBlind: 600, bigBlind: 1200, ante: 1200 },
                { smallBlind: 800, bigBlind: 1600, ante: 1600 },
                { smallBlind: 1000, bigBlind: 2000, ante: 2000 },
                { smallBlind: 1200, bigBlind: 2400, ante: 2400 },
                { smallBlind: 1500, bigBlind: 3000, ante: 3000 },
                { smallBlind: 2000, bigBlind: 4000, ante: 4000 },
                { smallBlind: 2500, bigBlind: 5000, ante: 5000 },
                { smallBlind: 3000, bigBlind: 6000, ante: 6000 },
                { smallBlind: 4000, bigBlind: 8000, ante: 8000 },
                { smallBlind: 5000, bigBlind: 10000, ante: 10000 },
            ].map(l => ({ ...l, duration: 30 }));
            break;
    }

    return levels;
}
